var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.691 2.02443C6.77304 1.9425 6.88423 1.89648 7.00017 1.89648C7.11611 1.89648 7.22731 1.9425 7.30934 2.02443L10.8093 5.52443C10.8523 5.56449 10.8868 5.61279 10.9107 5.66645C10.9346 5.72012 10.9475 5.77805 10.9485 5.83679C10.9496 5.89554 10.9387 5.95389 10.9167 6.00836C10.8947 6.06284 10.862 6.11233 10.8204 6.15387C10.7789 6.19542 10.7294 6.22817 10.6749 6.25017C10.6205 6.27217 10.5621 6.28298 10.5034 6.28194C10.4446 6.28091 10.3867 6.26805 10.333 6.24414C10.2794 6.22023 10.2311 6.18575 10.191 6.14277L7.43767 3.38943V11.6669C7.43767 11.783 7.39158 11.8942 7.30953 11.9763C7.22748 12.0583 7.1162 12.1044 7.00017 12.1044C6.88414 12.1044 6.77286 12.0583 6.69081 11.9763C6.60876 11.8942 6.56267 11.783 6.56267 11.6669V3.38943L3.80934 6.14277C3.76928 6.18575 3.72098 6.22023 3.66732 6.24414C3.61365 6.26805 3.55572 6.28091 3.49698 6.28194C3.43823 6.28298 3.37988 6.27217 3.32541 6.25017C3.27093 6.22817 3.22144 6.19542 3.1799 6.15387C3.13835 6.11233 3.1056 6.06284 3.0836 6.00836C3.0616 5.95389 3.05079 5.89554 3.05183 5.83679C3.05286 5.77805 3.06572 5.72012 3.08963 5.66645C3.11354 5.61279 3.14802 5.56449 3.191 5.52443L6.691 2.02443Z",
    fill: "#2C9543"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGainIcon);
export default __webpack_public_path__ + "static/media/gain_icon.9f266f1e63e75b90f1b2716715a1f55a.svg";
export { ForwardRef as ReactComponent };